module.exports = __webpack_public_path__ + "static/media/29BDOS3.d5aa5a71.jpg";